export const useStoreDevice = defineStore('StoreDevice', {
    state: () => ({
        device: null,
        browser: null,
    }),
    actions: {
        detectDevice() {
            if (import.meta.server) return;
            const userAgent = navigator?.userAgent;
            if (!userAgent) return;

            // Device detection
            if (/iPad/.test(userAgent) && !window.MSStream) {
                this.device = 'ipad';
            } else if (/iPhone|iPod/.test(userAgent) && !window.MSStream) {
                this.device = 'iphone';
            } else if (/Android/.test(userAgent)) {
                if (/Mobile|Android.*Mobile/.test(userAgent)) {
                    this.device = 'android-mobile';
                } else {
                    this.device = 'android-tablet';
                }
            } else if (/Windows/.test(userAgent)) {
                if (/Windows Phone/.test(userAgent)) {
                    this.device = 'windows-phone';
                } else {
                    this.device = 'windows';
                }
            } else if (/Macintosh/.test(userAgent)) {
                // Check for iPad disguised as Mac
                if (/iPad|MacIntel/.test(userAgent) && navigator?.maxTouchPoints > 1) {
                    this.device = 'ipad';
                } else {
                    this.device = 'mac';
                }
            } else if (/CrOS/.test(userAgent)) {
                this.device = 'chromebook';
            } else if (/Linux/.test(userAgent) && !/Android/.test(userAgent)) {
                this.device = 'linux';
            } else if (/Smart TV|WebOS|Tizen|SMART-TV|AppleTV|tvOS/.test(userAgent)) {
                this.device = 'smart-tv';
            } else {
                this.device = 'unknown';
            }

            // Browser detection
            if (/SamsungBrowser/.test(userAgent)) {
                this.browser = 'samsung-browser';
            } else if (/Chrome/.test(userAgent) && !/Chromium|Edge|Edg|OPR|Samsung/.test(userAgent)) {
                if (/Brave/.test(userAgent)) {
                    this.browser = 'brave';
                } else {
                    this.browser = 'chrome';
                }
            } else if (/Firefox|FxiOS/.test(userAgent) && !/Seamonkey/.test(userAgent)) {
                this.browser = 'firefox';
            } else if (/Safari/.test(userAgent) && !/Chrome|Chromium|Edge|Edg|OPR|Samsung/.test(userAgent)) {
                this.browser = 'safari';
            } else if (/Edge|Edg/.test(userAgent)) {
                this.browser = 'edge';
            } else if (/OPR|Opera/.test(userAgent)) {
                this.browser = 'opera';
            } else if (/MSIE|Trident/.test(userAgent)) {
                this.browser = 'ie';
            } else {
                this.browser = 'unknown';
            }

            // console.log('User agent:', userAgent);
            console.log('Device:', this.device, 'Browser:', this.browser);
        },
    },
});
